import React from 'react'

const clientesRoutes = [
    {
        path: '/configuracoes/provedores',
        exact: true,
        component: React.lazy(() => import('./providers/lista/Table')),
    },
    {
        path: '/configuracoes/recompensas',
        exact: true,
        component: React.lazy(() => import('./recompensas/lista/Table')),
    },
    {
        path: '/configuracoes/listas',
        exact: true,
        component: React.lazy(() => import('./listas/lista/Table')),
    },
    {
        path: '/configuracoes/listas/novo',
        exact: true,
        component: React.lazy(() => import('./listas/form/Form')),
    },
    // {
    //     path: '/clientes/cupons/novo',
    //     exact: true,
    //     component: React.lazy(() => import('./cupons/form/CupomForm')),
    // },
    // {
    //     path: '/clientes',
    //     exact: true,
    //     component: React.lazy(() => import('./cadastros/lista/Table')),
    // },
    // {
    //     path: '/clientes/novo',
    //     exact: true,
    //     component: React.lazy(() => import('./cadastros/form/Form')),
    // }, 
    // {
    //     path: '/clientes/resgates',
    //     exact: true,
    //     component: React.lazy(() => import('./resgates/lista/Table')),
    // }, 
]

export default clientesRoutes
